import { environment } from '../../environments/environment';

export const Constants = {
  baseUrl: environment.apiBaseUrl,
  tokenKey: 'JW_TOKEN',
  refreshTokenKey: 'JW_REFRESH_TOKEN',
  userKey: 'USER_DATA',
  // Origen de la sesión activa: 'local' (usuario/contraseña) o 'entra' (cuenta Microsoft).
  // Lo usa el logout para saber si además debe cerrar la sesión de MSAL.
  authProviderKey: 'AUTH_PROVIDER',
};

export type AuthProvider = 'local' | 'entra';
